export class Kullanici {
    adisoyadi: string = '';
    aud: string = '';
    exp: number = 0;
    iss: string = '';
    kullanici_id: string = '';
    nbf: number = 0;
    tckimlikno: string = '';
    Rol: string[] = [];
}